import React from 'react';
import { classNames } from '../../utils/helpers';

const Select = React.forwardRef(({ 
  className = '', 
  error = false,
  children,
  ...props 
}, ref) => {
  return (
    <select
      ref={ref}
      className={classNames(
        'w-full bg-slate-800/50 backdrop-blur-sm text-white rounded-xl px-4 py-3',
        'border transition-all duration-200',
        'focus:outline-none focus:ring-2',
        error 
          ? 'border-red-500/50 focus:border-red-500 focus:ring-red-500/20' 
          : 'border-white/10 focus:border-orange-500 focus:ring-orange-500/20',
        'hover:border-white/20',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        '[&>option]:bg-slate-800 [&>option]:text-white',
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
});

Select.displayName = 'Select';

export default Select;
